export { default as User } from "./user.component";

import * as actions from "./user.actions";
import * as sagas from "./user.sagas";

export { actions, sagas };